import PropTypes from 'prop-types';

const propTypeProductImage = PropTypes.shape({
	Headline: PropTypes.string,
	ImgAlt: PropTypes.string.isRequired,
	ImgPath: PropTypes.string,
	ImgSrc: PropTypes.string.isRequired,
	VideoId: PropTypes.string
});
const propTypeCustomerImage = PropTypes.shape({
	alt_text: PropTypes.string
});
const propTypeProduct = PropTypes.shape({
	AdjustedInventory: PropTypes.number,
	CalloutText: PropTypes.string,
	DisplayPrice: PropTypes.string,
	ImageBaseUrl: PropTypes.string,
	Images: PropTypes.arrayOf(propTypeProductImage),
	IsDecrementable: PropTypes.bool,
	PrimaryCategory: PropTypes.string,
	PrimaryColor: PropTypes.string,
	PrimaryFinish: PropTypes.string,
	PrimaryType: PropTypes.string,
	PrimaryStyle: PropTypes.string,
	ProductDetailUrl: PropTypes.string,
	ProductName: PropTypes.string,
	ShortSku: PropTypes.string,
	ShowInventory: PropTypes.bool,
	SoldOut: PropTypes.bool,
	SkuInputType: PropTypes.number,
	SavePrice: PropTypes.oneOfType([ PropTypes.string.isRequired, PropTypes.number.isRequired ]),
	IsOnSale: PropTypes.bool,
	ExtraLargeImageUrl: PropTypes.string,
	Price: PropTypes.oneOfType([ PropTypes.string.isRequired, PropTypes.number.isRequired ])
});

const propTypeProductSortItemDisplayOptions = PropTypes.shape({
	showAddToCart: PropTypes.bool,
	showMoreLikeThis: PropTypes.bool,
	showSaleCallout: PropTypes.bool,
	showSavePrice: PropTypes.bool,
	showShippingCallout: PropTypes.bool,
	optionsByShortSku: PropTypes.object /* eslint-disable-line react/forbid-prop-types */
});

export {
	propTypeProductImage, propTypeProduct, propTypeCustomerImage, propTypeProductSortItemDisplayOptions
};
